import { Suspense, lazy, useEffect } from "react";
import { Navigate, useRoutes } from "react-router-dom";

// layouts
import DashboardLayout from "../layouts/dashboard";
import AuthLayout from "../layouts/main/AuthLayout";
// config
import { DEFAULT_PATH } from "../config";
import LoadingScreen from "../components/LoadingScreen";

const Loadable = (Component) => (props) => {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );
};

// Mock authentication function (replace with actual authentication check)
const isAuthenticated = () => {
  return localStorage.getItem("userId"); // Replace with real authentication check
};

export default function Router() {
  return useRoutes([
    {
      path: '/auth',
      element: isAuthenticated() ? <Navigate to="/app" replace /> : <AuthLayout />,
      children: [
        { path: 'login', element: <LoginPage /> },
        { path: 'register', element: <RegisterPage /> },
        { path: 'reset-password', element: <ResetPasswordPage /> },
        { path: 'new-password', element: <NewPasswordPage /> },
      ],
    },
    {
      path: "/",
      element: isAuthenticated() ? <DashboardLayout /> : <Navigate to="/website" replace />,
      children: [
        { element: <Navigate to={DEFAULT_PATH} replace />, index: true },
        { path: "app", element: <GeneralApp /> },
        { path: "settings", element: <Settings /> },
        { path: "group", element: <GroupPage /> },
        { path: "call", element: <CallPage /> },
        { path: "admin", element: <AdminPage /> },
        { path: "404", element: <Page404 /> },
        { path: "*", element: <Navigate to="/app" replace /> },
      ],
    },

     // Website routes
     {
      path: "/website",
      element: <WebsiteLayout />,
      children: [
        { index: true, element: <Home /> }, // Default page for /website
        { path: "pricing", element: <Pricing /> }, // website/pricing
        { path: "features", element: <Features /> }, // website/features
        { path: "demo", element: <Demo /> }, // website/demo
        { path: "help", element: <Help /> }, // website/demo
        { path: "how-it-works", element: <HowItworks /> }, // website/how-it-works
        { path: "contact", element: <Contact /> }, // website/how-it-works
      ],
    },


    { path: "*", element: <Navigate to="/app" replace /> },
  ]);
}

const GeneralApp = Loadable(lazy(() => import("../pages/dashboard/GeneralApp")));
const Settings = Loadable(lazy(() => import("../pages/dashboard/Settings")));
const LoginPage = Loadable(lazy(() => import("../pages/auth/Login")));
const RegisterPage = Loadable(lazy(() => import("../pages/auth/Register")));
const ResetPasswordPage = Loadable(lazy(() => import("../pages/auth/ResetPassword")));
const NewPasswordPage = Loadable(lazy(() => import("../pages/auth/NewPassword")));
const GroupPage = Loadable(lazy(() => import("../pages/dashboard/Group")));
const CallPage = Loadable(lazy(() => import("../pages/dashboard/Call")));
const AdminPage = Loadable(lazy(() => import("../pages/dashboard/Admin")));
const Page404 = Loadable(lazy(() => import("../pages/Page404")));



// Website components route import
const WebsiteLayout = Loadable(lazy(() => import("../website/index")));
const Home = Loadable(lazy(() => import("../website/pages/home")));
const Pricing = Loadable(lazy(() => import("../website/pages/Pricing")));
const Features = Loadable(lazy(() => import("../website/pages/Features")));
const Demo = Loadable(lazy(() => import("../website/pages/Demo")));
const Help = Loadable(lazy(() => import("../website/pages/Help")));
const HowItworks = Loadable(lazy(() => import("../website/pages/HowItworks")));
const Contact = Loadable(lazy(() => import("../website/pages/Contact")));